import ArrayType from './Array';
import DefaultType from './Default';
import NullableArrayType from './NullableArray';
import NullableObjectType from './NullableObject';
import ObjectType from './Object';
import ReferenceType from './Reference';
import ReferenceListType from './ReferenceList';

export default {
  Array: ArrayType,
  Default: DefaultType,
  NullableArray: NullableArrayType,
  NullableObject: NullableObjectType,
  Object: ObjectType,
  Reference: ReferenceType,
  ReferenceList: ReferenceListType,
};



// WEBPACK FOOTER //
// ./mixins/Form/Types/index.js